import React from 'react';

import classNames from 'classnames';
import { AutoSizer, Grid } from 'react-virtualized';

import SlideCanvas from './SlideCanvas';

const THUMB_WIDTH = 120;
const THUMB_GAP = 10;
const CELL_WIDTH = THUMB_WIDTH + THUMB_GAP;
const CELL_HEIGHT = 68 + 4 + 22;
const STRIP_HEIGHT = CELL_HEIGHT + 12;

/**
 * A strip of page thumbnails, each labelled with its number and title.
 * Virtualised, because a pack can run to a thousand slides; charts are drawn
 * as placeholders at this size.
 */
const PageStrip = ({ pages, current, onSelect, watermark }) => (
    <div style={{ height: STRIP_HEIGHT }}>
        <AutoSizer disableHeight>
            {({ width }) => (
                <Grid
                    width={width}
                    height={STRIP_HEIGHT}
                    rowCount={1}
                    rowHeight={CELL_HEIGHT}
                    columnCount={pages.length}
                    columnWidth={CELL_WIDTH}
                    scrollToColumn={current}
                    overscanColumnCount={4}
                    cellRenderer={({ columnIndex, key, style }) => {
                        const page = pages[columnIndex];
                        const selected = columnIndex === current;

                        return (
                            <div key={key} style={style} className="tw-pe-2.5">
                                <button
                                    type="button"
                                    onClick={() => onSelect(columnIndex)}
                                    aria-current={selected ? 'page' : undefined}
                                    className="tw-group tw-flex tw-flex-col tw-gap-1 tw-w-full tw-p-0 tw-border-0 tw-bg-transparent tw-text-start"
                                >
                                    <div
                                        aria-hidden="true"
                                        className={classNames(
                                            'tw-w-full tw-rounded tw-overflow-hidden tw-border-2 tw-bg-white tw-pointer-events-none',
                                            selected ? 'tw-border-blue' : 'tw-border-charcoal-15 group-hover:tw-border-blue-50',
                                        )}
                                    >
                                        <SlideCanvas page={page} thumbnail watermark={watermark} />
                                    </div>
                                    <span className="tw-block tw-w-full tw-truncate tw-text-xs tw-text-charcoal-75">
                                        <span className="tw-font-semibold tw-text-charcoal">{columnIndex + 1}</span> {page.title}
                                    </span>
                                </button>
                            </div>
                        );
                    }}
                />
            )}
        </AutoSizer>
    </div>
);

export default PageStrip;
